'use client';
import { READY_LANG } from '@/constants';
// 检测当前语言是否全面兼容前端界面和后端 API
export const isReadyLang = (locale: string) => {
    return READY_LANG?.includes(locale);
};
export const setLocaleQuery = (locale?: string) => {
    // V1.2.0 只对四个英文版切换 appid（ENGLISH_LANG 包含了 us, uk, ca, au）
    return typeof locale !== 'undefined' && isReadyLang(locale) ? `?locale=${locale}` : '';
};